const SELECTOR = {
  CONTAINER: '[data-add-ons]',
  GROUP: '[data-add-on-group]',
  INPUT: '[data-add-on-input]',
  CART_ITEMS: '[data-add-on-cart-items]',
  TOOLTIP: '[data-tippy-content]',
};

const BUY_BAR_FORM_SUFFIX = '-product-buy-bar';

elabs.ProductAddOns = class {
  constructor(element) {
    this.view = element;
    this.selectedAddOnIds = new Map();
    this.wireEvents();
    this.rememberSelection();
    this.updateCartItems();
    this.initialiseTooltips();
  }

  get groups() {
    return Array.from(this.view.querySelectorAll(SELECTOR.GROUP));
  }

  get inputs() {
    return Array.from(this.view.querySelectorAll(SELECTOR.INPUT));
  }

  wireEvents = () => {
    this.view.addEventListener('change', this.handleChange);
    new MutationObserver(this.handleRender).observe(this.view, { childList: true });
    document.addEventListener('submit', this.handleFormSubmit, true);
  };

  handleChange = (event) => {
    if (!event.target.matches(SELECTOR.INPUT)) {
      return;
    }

    this.rememberSelection();
    this.updateCartItems();
  };

  handleRender = () => {
    this.restoreSelection();
    this.rememberSelection();
    this.updateCartItems();
    this.initialiseTooltips();
  };

  rememberSelection = () => {
    this.groups.forEach((group) => {
      const selectedInputs = Array.from(group.querySelectorAll(`${SELECTOR.INPUT}:checked`));
      this.selectedAddOnIds.set(
        group.dataset.addOnGroup,
        selectedInputs.map((input) => input.dataset.addOnId),
      );
    });
  };

  restoreSelection = () => {
    this.groups.forEach((group) => {
      const selectedAddOnIds = this.selectedAddOnIds.get(group.dataset.addOnGroup);
      if (!selectedAddOnIds) {
        return;
      }

      const groupInputs = Array.from(group.querySelectorAll(SELECTOR.INPUT));
      const isRestorable = (input) => !input.disabled && selectedAddOnIds.includes(input.dataset.addOnId);
      if (selectedAddOnIds.length > 0 && !groupInputs.some(isRestorable)) {
        return;
      }

      groupInputs.forEach((input) => {
        input.checked = isRestorable(input);
      });
    });
  };

  updateCartItems = (quantity = 1) => {
    const cartItems = this.view.querySelector(SELECTOR.CART_ITEMS);
    if (!cartItems) {
      return;
    }

    const selectedInputs = this.inputs.filter((input) => input.checked && !input.disabled && input.value);
    cartItems.replaceChildren(
      ...selectedInputs.flatMap((input) => [
        this.createCartInput('upsell-id', input.value),
        this.createCartInput('upsell-quantity', quantity),
      ]),
    );
  };

  createCartInput = (className, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.className = className;
    input.value = value;
    return input;
  };

  initialiseTooltips = () => {
    elabs.initialiseTooltips?.(Array.from(this.view.querySelectorAll(SELECTOR.TOOLTIP)));
  };

  handleFormSubmit = (event) => {
    const submittedForm = event.target;
    const productFormId = this.view.dataset.productFormId;
    if (!this.view.isConnected || !productFormId || !(submittedForm instanceof HTMLFormElement)) {
      return;
    }

    const submittedFormId = submittedForm.getAttribute('id');
    if (submittedFormId !== productFormId && submittedFormId !== `${productFormId}${BUY_BAR_FORM_SUFFIX}`) {
      return;
    }

    const invalidInput = this.inputs.find((input) => !input.checkValidity());
    if (invalidInput) {
      event.preventDefault();
      event.stopImmediatePropagation();
      invalidInput.reportValidity();
      invalidInput.focus();
      return;
    }

    const quantity = parseInt(new FormData(submittedForm).get('quantity')) || 1;
    this.updateCartItems(quantity);
  };
};

const initProductAddOns = () => {
  document.querySelectorAll(SELECTOR.CONTAINER).forEach((element) => {
    if (element.dataset.initialized === 'true') {
      return;
    }
    element.dataset.initialized = 'true';
    void new elabs.ProductAddOns(element);
  });
};

initProductAddOns();

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initProductAddOns);
}
